import { Component, Input, NgModule, OnInit } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser'

import { ConfirmationService } from 'primeng/primeng';

import { ConstantsService } from 'app/services/constants-service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { GlobalValuesService } from 'app/services/global-values.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';

import { LegalStructureService } from './legal-structure.service';

@Component({
    selector: 'legal-structure-search',
    providers: [LegalStructureService, ConfirmationService],
    templateUrl: './legal-structure.component.html',
})

/**
 * Component for Legal Structure Search Results and Pop-up items.
 */
export class LegalStructureComponent implements OnInit {
    // Overall filtered search results.
    filteredLegalStructures: any[] = [];
    // Fetched Legal Structure Values.
    arrLegalStructureSearchResults: any[] = [];
    // Model value for search box.
    @Input() legalStructureValue: string;
    // Search Query string.
    query: string;
    // Legal Structure filtered values.
    public filteredValues: any[] = [];

    // Constructor method
    constructor(
        private legalStructureService: LegalStructureService,
        private confirmationService: ConfirmationService,
        private snackBarService: SnackBarService,
        private warmUpService: WarmUpService,
        private globalValuesService: GlobalValuesService
    ) { }

    ngOnInit() {
        // Get Legal structure values from warm-up service.
        this.arrLegalStructureSearchResults = this.warmUpService.getApplicationValue(ApplicationTypeConstants.LEGAL_STRUCTURE);
    }

    // Method to filter Legal Structures locally as we are getting full list from
    // the back-end.
    filterLegalStructures(query, legalStructures: any[]): any[] {
        let filteredSearchValues: any[] = [];
        for (let lsKey in legalStructures) {
            let legalStructureRecord = legalStructures[lsKey];
            if (legalStructureRecord.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                // Filtered record object to be passed to search element to
                // be displayed on the screen.
                filteredSearchValues.push(
                    {
                        'id': legalStructureRecord.id,
                        'type': 'ls',
                        'value': legalStructureRecord.name
                    });
            }
        }
        // Made this assignment as these values are required publically for
        // other methods of this class.
        this.filteredValues = filteredSearchValues;
        return filteredSearchValues;
    }

    // This method is to return ID of the selected legal structure. As Legal
    // Structure is not a drop-down now, but an input box. So, it provides
    // Legal Structure text, but to save it for new organisation, we need
    // ID value that is an integer.
    getLegalStructureIDValue(selectedLegalStructuresName: string): number {
        let numSelectedLegalStructureID: number = 0;
        for (let lsFilteredKey in this.filteredValues) {
            let objLegalStructureRecord = this.filteredValues[lsFilteredKey];
            if (selectedLegalStructuresName.trim() == objLegalStructureRecord.value.trim()) {
                numSelectedLegalStructureID = objLegalStructureRecord.id;
            }
        }
        return numSelectedLegalStructureID;
    }

    // Method to get all values of Legal Structures from back-end, send them to
    // appropriate method to filter results as per query string and returning the
    // filter search results back to view to display them in search box.
    getFilteredLegalStructures(event) {
        // Search Query
        this.query = event.query;

        // Get results from the service class.
        this.legalStructureService.getLegalStructureSearchResults()
            .subscribe
            (
            response => {
                // Reset final search results array to blank value to refresh
                // search data for each search iteration.
                this.filteredLegalStructures = [];
                // Count of record objects before filtering locally.
                let countLegalStructureTotalRecords: number = 0;
                // Count of record objects after filtering locally.
                let countLegalStructureSearchResults: number = 0;
                // Legal Structures records object from back-end.
                let arrLegalStructureSearchResults = response.arrResult.values;
                if (arrLegalStructureSearchResults) {
                    let countLegalStructureTotalRecords = Object.keys(arrLegalStructureSearchResults).length;
                    // If we get 'n'( > 0 ) number of records from back-end, then
                    // filter them locally as per search query string.
                    if (countLegalStructureTotalRecords > 0) {
                        this.filteredLegalStructures = this.filterLegalStructures(this.query, arrLegalStructureSearchResults);
                    }
                }

                // Always show the add Legal Structure
                this.filteredLegalStructures.push(
                    {
                        'id': null,
                        'type': 'nls',
                        'value': "Add as new Legal Structure"
                    });

                }
            );
    }

    // Method to add new requested Legal Structure value to database.
    // @todo To improve confirm box and alert box to display the confirmation
    // messages to the user. Also to improve some css related to searc box.
    // Also to add message values to some cental language file.
    processAddNewRequest(selectedSearchResult) {
        let searchQuery: string = (this.query) ? this.query : '';
        if (selectedSearchResult.type && selectedSearchResult.type.toLowerCase() == 'nls') {
            this.legalStructureValue = "";
            this.confirmationService.confirm({
                message: "Are you sure you want to add '" + searchQuery + "' as a new legal structure?",
                accept: () => {
                    this.legalStructureService.addLegalStructure(searchQuery, ApplicationTypeConstants.LEGAL_STRUCTURE)
                        .subscribe(
                        success => {
                            this.callSnackBarService(success);
                            this.globalValuesService.gblLegalStructureSelectedIDValue = success.arrResult.id;
                            this.legalStructureValue = searchQuery;
                        },
                        err => {
                            this.callSnackBarService(err);
                        }
                        );
                }
            });
        }
        else {
            if (selectedSearchResult.value) {
                let legalStructureIDValue = this.getLegalStructureIDValue(selectedSearchResult.value);
                this.globalValuesService.gblLegalStructureSelectedIDValue = legalStructureIDValue;
            }
        }
    }

    // Method to display Success or Failure message at the bottom of body.
    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.CREATE_LEGAL_STRUCTURE_SUCCESS,
            MessageService.CREATE_LEGAL_STRUCTURE_FAILURE);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/legalstructure/legal-structure.component.ts